import React, { Component, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import useUserStore from '../../stores/Users';

import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import { baseAPI } from '../../services/baseAPI';

function ForgetPassword() {
  const history = useHistory();

  const {login, validationReport} = useUserStore((state) => state);
  const [email, setEmail] = useState("");
  const [kodeOTP, setKodeOTP] = useState("");
  const [newPassword, setNewPassword] = useState(null);
  const [reNewPassword, setReNewPassword] = useState(null);
  const [validOTP, setValidOTP] = useState(false);
  const [showPass, setShowPass] = useState();
  const [loading, setLoading] = useState(false);

  // CONTROLLER
  const sendOTP = () => {
    setLoading(true);
    const body = new FormData();
    body.append('email', email);

    baseAPI
      .put(`/v1/kodeotp`, body, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        Swal.fire({
          icon: 'success',
          title: "Kode OTP berhasil terkirim. Cek email anda sekarang.",
          showConfirmButton: false,
          timer: 1500
        })
        // console.log(`berhasil terkirim ${JSON.stringify(res)}`);
        console.log(`berhasil terkirim`);
      })
      .catch((error) => {
        setLoading(false);
        console.log('error: ', error);
        Swal.fire({
          icon: 'error',
          title: "Gagal mengirim kode OTP.",
          showConfirmButton: false,
          timer: 1500
        })
      })
      .finally(() => {
        setLoading(false);
      })
  };

  const checkOTP = async () => {
    setLoading(true);
    const body = new FormData();
    body.append('email', email);
    body.append('kodeotp', kodeOTP);

    await baseAPI 
      .post(`/v1/kodeotp`, body, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.data.success === 'true') {
          setValidOTP(true);
        } else {
          Swal.fire({
            icon: 'error',
            title: `Kode OTP anda tidak valid.`,
            showConfirmButton: false,
            timer: 1500
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal memvalidasi kode OTP`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
        // console.log(kodeOTP);
        setEmail("");
        setKodeOTP("");
      })
      .finally(() => {
        setLoading(false);
      })
  };

  const updatePassword = () => {
    Swal.fire({
      title: 'Apakah anda yakin ingin memperbarui password anda?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);

        const body = new FormData();

        body.append('newpass', reNewPassword);
        body.append('kodeotp', kodeOTP);

        baseAPI
          .put(`/v1/resetpass`, body, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Password anda berhasil diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil update.`);
            history.push('/');
          })
          .catch((error) => {
            setLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Gagal memperbarui password anda.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setLoading(false);
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });
  }

  // VIEW
  return (
    <div className='container'>
      <div className='row' style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh'
        }}>
        <div className='col-lg-3 col-md-auto'>
          <div className='card border-light mb-3' style={{boxShadow: '1px 2px 9px #D2D2D2'}}>
            <div className='card-body text-dark'>
              <p style={{fontSize: 20, fontWeight: 'bold', textAlign:'center'}}>KOPKAR DASHBOARD</p>
              {loading ? <LoadingView /> 
              :
                <form>
                  
                  {validOTP === false ?
                  <>
                    {/* Email */}
                    <div className='mb-3'>
                      <label for="email" className='form-label'>Email</label>
                      <input 
                        className='form-control' 
                        id="email" 
                        style={{backgroundColor: '#f3f4f6'}}
                        placeholder="Masukan email anda"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    {/* Kode OTP */}
                    <div className='mb-3'>
                      <label for="otp" className='form-label'>Kode OTP</label>
                      <input 
                        className='form-control' 
                        id="otp" 
                        style={{backgroundColor: '#f3f4f6'}}
                        placeholder="Masukan kode OTP"
                        onChange={(e) => setKodeOTP(e.target.value)}
                      />
                    </div>

                    {/* Button Kirim kode OTP via email */}
                    <div className="mb-3 mt-3">
                        <button
                          disabled={email != "" && kodeOTP === "" ? false : true}
                          type="submit"
                          className="btn btn-success w-100"
                          style={{backgroundColor: '#6A9C89'}}
                          onClick={() => sendOTP()}
                        >
                          Kirim OTP
                        </button>
                    </div>

                    {/* Button Submit kode OTP from email */}
                    <div className="mb-3 mt-3">
                        <button
                          disabled={kodeOTP != "" ? false : true}
                          type="submit"
                          className="btn btn-danger w-100"
                          style={{backgroundColor: '#CD5C08'}}
                          onClick={() => checkOTP()}
                        >
                          Submit OTP
                        </button>
                    </div>
                  </>
                  : 
                  <>
                    {/* New Password */}
                    <div className="mb-2">
                      <label htmlFor="true" className="form-label">
                        Password Baru
                      </label>
                      <div className="input-group input-group-flat">
                        <input
                          type={showPass ? 'text' : 'password'}
                          hidden={false}
                          className="form-control"
                          style={{backgroundColor: '#f3f4f6'}}
                          placeholder="Masukan password baru"
                          autoComplete="off"
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <span
                          className="btn input-group-text"
                          onClick={() => setShowPass(!showPass)}
                          aria-hidden="true"
                        >
                          <Icon name={showPass ? 'EyeOff' : 'Eye'} size={16} style={{ marginLeft: 15 }} />
                        </span>
                      </div>
                    </div>

                    {/* Retype New Password */}
                    <div className="mb-2">
                      <label htmlFor="true" className="form-label">
                        Ulangi Password Baru
                      </label>
                      <div className="input-group input-group-flat">
                        <input
                          type={showPass ? 'text' : 'password'}
                          hidden={false}
                          className="form-control"
                          style={{backgroundColor: '#f3f4f6'}}
                          placeholder="Masukan ulang password baru"
                          autoComplete="off"
                          onChange={(e) => setReNewPassword(e.target.value)}
                        />
                        <span
                          className="btn input-group-text"
                          onClick={() => setShowPass(!showPass)}
                          aria-hidden="true"
                        >
                          <Icon name={showPass ? 'EyeOff' : 'Eye'} size={16} style={{ marginLeft: 15 }} />
                        </span>
                      </div>
                    </div>
                    
                    {/* Button Update Password */}
                    <div className="mb-3 mt-3">
                        {newPassword === reNewPassword ? false : <p>Konfirmasi password baru belum sesuai. Periksa kembali password baru anda.</p>}
                        <button
                          disabled={newPassword === reNewPassword && newPassword !== null && reNewPassword !== null ? false : true}
                          type="button"
                          className="btn btn-danger w-100"
                          style={{backgroundColor: '#CD5C08'}}
                          onClick={() => updatePassword()}
                        >
                          Update Password
                        </button>
                    </div>
                  </>}

                </form>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default ForgetPassword;